import { HttpErrorResponse } from '@angular/common/http';
import { Actions, ofActionDispatched } from '@ngxs/store';
import { BackendErrorResponse } from '@zero/shared/util-models';
import { Observable } from 'rxjs';
import { AlertStateFacade } from './alert/alert-state-facade';
import { LogoutUser } from './auth/auth.actions';

export class BaseState {
  public userLoggedOut$: Observable<LogoutUser>;

  constructor(
    private _alertStateFacade: AlertStateFacade,
    actions$: Actions,
  ) {
    this.userLoggedOut$ = actions$.pipe(ofActionDispatched(LogoutUser));
  }

  public handleBackendError(errorResponse: unknown, defaultMessage?: string): Observable<void> {
    const backendErrorMessage = this.getBackendErrorFromHttpError(errorResponse);
    return this._alertStateFacade.addErrorAlert({
      message: this.getMessageFromError(backendErrorMessage, defaultMessage),
    });
  }

  private getBackendErrorFromHttpError(error: unknown): BackendErrorResponse {
    if (error instanceof HttpErrorResponse) {
      if ([401, 403].includes(error.status)) {
        return {
          message: 'Bitte logge Dich erneut ein',
          status: error.status.toString(),
          errors: [error.error],
        } as BackendErrorResponse;
      }

      if (error.error && error.status !== 503) {
        if (typeof error.error === 'string') {
          try {
            return JSON.parse(error.error) as BackendErrorResponse;
          } catch {
            return {
              message: undefined,
              status: error.status.toString(),
              errors: [error.error],
            } as BackendErrorResponse;
          }
        } else {
          return error.error as BackendErrorResponse;
        }
      } else {
        return {
          message: error.message,
          status: error.status.toString(),
          errors: [error.error],
        } as BackendErrorResponse;
      }
    } else {
      console.error('Store Error', error);
      return {} as BackendErrorResponse;
    }
  }

  private getMessageFromError(err: BackendErrorResponse, defaultMessage?: string): string {
    if (err?.message) {
      return err.message;
    } else if (defaultMessage) {
      return defaultMessage;
    } else {
      return 'Es ist ein Fehler aufgetreten. Bitte versuche es später noch einmal.';
    }
  }
}
